import { useState } from 'react';
import * as Icons from 'react-bootstrap-icons';
import Table from 'react-bootstrap/Table';
import Collapse from 'react-bootstrap/Collapse';
import Chart from './Chart';
import CommandInterface from './OverviewCommandInterface';

const status_color = (value, low_limit, high_limit) => {
  //console.log('status_color', value, low_limit, high_limit)
  
  let result_color = '';


  //return 'warning';

  // Jos mikä tahansa syötetyistä arvoista on antamatta, palautetaan ilman värikoodia.
  // TODO: Periaatteessa low tai high limit voisi jompikumpi olla täyttämättä.
  if (value === undefined || low_limit === undefined || high_limit === undefined)
    return result_color;


  if (value <= low_limit || value >= high_limit)
    result_color = 'table-danger';

  return result_color;
}

const Device = ({ mcadexinterface, item, measurements, userLevel, history, main_callback }) => {

    const [controlCollapse, setControlCollapse] = useState(false);
    const [chartCollapse, setChartCollapse] = useState(false);
  
    //let testi = JSON.stringify(measurements);
    //console.log('eka', measurements)
    
    if (measurements == 0)
      return; 
  
  
    //if (config) {
      //console.log('test', config.map((rivi) => rivi['mac']))
      //console.log(`devices ${config}\n${measurements})`)
  
      //let site_config = config.find(x => x['site'] === site);
  
  
      let i_factor = 0.001;
      let u_factor = 0.001;
      //console.log('test', item)
  
      //console.log('toimi', item, item['mac'])
      //console.log('measuremetnasjson', measurements)
      let mac = item['mac'].toString();
      //console.log('mac', mac)
      let type = item['type'];
      let device_measurements = measurements[item['mac']];
      //console.log('device_measuremetns', device_measurements)
      let current = device_measurements ? device_measurements['iout']  : undefined;
      let voltage = device_measurements ? device_measurements['uout']  : undefined;
      let ref1 = device_measurements ? device_measurements['ref1abs'] : undefined;
      let ref2 = device_measurements ? device_measurements['ref2abs'] : undefined;
      let ref1pol = device_measurements ? Number(device_measurements['ref1pol']) : undefined;
      let ref2pol = device_measurements ? Number(device_measurements['ref2pol']) : undefined;
      //let i_gain = device_measurements ? Number(device_measurements['i_gain']) : 1;
      //let u_gain = device_measurements ? Number(device_measurements['u_gain']) : 1;
      let mtype = device_measurements ? device_measurements['mtype'] : undefined;
      let control = device_measurements ? device_measurements['control'] : undefined;
      let setpoint = device_measurements ? (Number(device_measurements['setpoint']).toFixed(1)) : undefined;
      let output = device_measurements ? device_measurements['output'] : undefined;
      //let site = item['site'];
      let site = item['name'];

      // Limitit
      let i_low_limit = item['i_low_limit'];
      let i_high_limit = item['i_high_limit'];
      let u_low_limit = item['u_low_limit'];
      let u_high_limit = item['u_high_limit'];

      //console.log('limitit', i_low_limit, i_high_limit, u_low_limit, u_high_limit)

      // Kanavien väärikoodit
      let current_value = current * i_factor;
      let voltage_value = voltage * u_factor;
      let current_color = status_color(current_value, i_low_limit, i_high_limit)
      let voltage_color = status_color(voltage_value, u_low_limit, u_high_limit)

      // mcadex rivit
      if (mcadexinterface) {
        return (
          <>
            <tr key={mac}>
              {/*<td  style={{cursor: 'pointer'}} onClick={() => setControlCollapse(!controlCollapse)}>{item['customer']}-{controlCollapse.toString()}</td>*/}
              {/*<td>{item['customer']}</td>*/}
              <td><b>{item['name']}</b></td>
              {/*<td className={status_color(current_value)}>{(current * i_factor).toFixed(2)}</td>*/}
              {/*<td className={current_color}>{(current_value).toFixed(2)}</td>*/}
              <td className='warning'>{(current_value).toFixed(2)}</td>
              <td className={voltage_color}>{(voltage_value).toFixed(2)}</td>
              <td>{ref1}</td>
              <td>{ref1pol}</td>
              <td>{ref2}</td>
              <td>{ref2pol}</td>
              <td>{mtype}</td>
              <td>{control}</td>
              {/* Poistettu Amin pyynnöstä näkyvistä <td>{setpoint}</td>*/}
              <td>{output}</td>
              <td>{item['mac']}</td>
              <td>{item['type']}</td>
              <td>
                { (userLevel > 1 &&
                  <button className="btn btn-primary" title="Maintenance" disabled={item['type'] === 'm2ex'} onClick={() => setControlCollapse(!controlCollapse)}><Icons.Window/></button>
                )}
                
                <button className="btn btn-primary" title="Chart" data-placement="bottom" onClick={() => setChartCollapse(!chartCollapse)}><Icons.GraphUp/></button>
              </td>
            </tr>
  
            {/* TODO: Nämä toteutettu vähän eritavalla. Muuta yhtenäiseksi. */}
            
            <Collapse in={controlCollapse}>
              <CommandInterface mac={mac} type={type} measurements={device_measurements} main_callback={main_callback} show={controlCollapse}></CommandInterface>
            </Collapse>
  
            <Collapse in={chartCollapse}>
              <tr>
                <td colSpan="15"> 
                  <Chart name={site} device={mac} history={history}></Chart>
                </td>
              </tr>
            </Collapse>
                
          </>
        )
      }
      // m2ex rivit
      else {
        return (
          <>
            <tr key={mac}>
              <td><b>{item['name']}</b></td>
              {/*
              <td>{(current * i_factor).toFixed(2)}</td>
              <td>{(voltage * u_factor).toFixed(2)}</td>
            */}
{/*              <td className={current_color}>{(current_value).toFixed(2)}</td> */}
              <td className='warning'>{(current_value).toFixed(2)}</td>

              <td className={voltage_color}>{(voltage_value).toFixed(2)}</td>
              {/*<td>{item['mac']}</td>
              <td>{item['type']}</td>*/}
              <td>{i_low_limit}</td>
              <td>{i_high_limit}</td>
              <td>{u_low_limit}</td>
              <td>{u_high_limit}</td>
              <td>
                <button className="btn btn-primary" title="Maintenance" disabled={item['type'] === 'm2ex'} onClick={() => setControlCollapse(!controlCollapse)}><Icons.Window/></button>
                <button className="btn btn-primary" title="Chart" data-placement="bottom" onClick={() => setChartCollapse(!chartCollapse)}><Icons.GraphUp/></button>
              </td>
            </tr>
  
            {/* TODO: Nämä toteutettu vähän eritavalla. Muuta yhtenäiseksi. */}
            
            <Collapse in={controlCollapse}>
              <CommandInterface mac={mac} type={type} measurements={device_measurements} main_callback={main_callback} show={controlCollapse}></CommandInterface>
            </Collapse>
  
            <Collapse in={chartCollapse}>
              <tr>
                <td colSpan="15"> 
                  <Chart name={site} device={mac} history={history}></Chart>
                </td>
              </tr>
            </Collapse>
                
          </>
        )
      }
  
    
    //}
  
  }
  
  
  
  const Devices = ({ mcadexinterface, site, config, measurements, userLevel, history, main_callback}) => {
  
    const [controlCollapse, setControlCollapse] = useState(false)
  
    //let testi = JSON.stringify(measurements);
    //console.log('eka', site, measurements)
    
    if (measurements == 0)
      return; 
  
  
    if (config) {
      //console.log('eka-plus', config)
  
      //console.log('test', config.map((rivi) => rivi['mac']))
      //console.log(`devices ${config}\n${measurements})`)
  
  
      //let site_config = config.find(x => x['name'] === site);
      let site_config = site;
      //console.log('site_config', site_config)

      // mcadex otsikot
      if (mcadexinterface) {
        return (
          <>
    
            {/*<Table striped bordered hover info="true">*/}
            {/* <Table striped hover info="true"> */}
            <Table>
              <thead>
                <tr>
                 {/* <th className="col-sm-1">Customer</th>*/}
                 {/*
                  <th className="col-sm-2">Desc</th>
                  <th>Current</th>
                  <th>Voltage</th>
                  <th>Ref 1</th>
                  <th>Ref 1 (pol)</th>
                  <th>Ref 2</th>
                  <th>Ref 2 (pol)</th>
                  <th>Mtype</th>
                  <th>Control</th>
                  <th>Setpoint</th>
                  <th>Output</th>
                  <th>Mac</th>
                  <th>Type</th>
                  <th>Views</th>
        */}
                  <th className="col-sm-2">Piiri</th>
                  <th>Virta</th>
                  <th>Jännite</th>
                  <th>Ref 1</th>
                  <th>Ref 1 (pol)</th>
                  <th>Ref 2</th>
                  <th>Ref 2 (pol)</th>
                  <th>Mtype</th>
                  <th>Control</th>
                  {/* <th>Setpoint</th>*/}
                  <th>Output</th>
                  <th>Mac</th>
                  <th>Type</th>
                  <th>Views</th>
                </tr>
              </thead>
              
              <tbody>
                  {site_config && site_config['devices'].map((item, index) => {
    
                    return <Device key={index} mcadexinterface={mcadexinterface} item={item} measurements={measurements} userLevel={userLevel} history={history} main_callback={main_callback} />
                  })}
              </tbody>
    
            </Table>
    
          </>
        )
      }
      // m2ex
      else
      {
        return (
          <>
    
            {/*<Table striped bordered hover info="true">*/}
            <Table>
              <thead>
                <tr>
                 {/* <th className="col-sm-1">Customer</th>*/}
                 {/*
                  <th className="col-sm-2">Desc</th>
                  <th>Current</th>
                  <th>Voltage</th>
                  <th>Mac</th>
                  <th>Type</th>
                  <th>Views</th>
        */}
                  <th className="col-sm-1">Piiri</th>
                  <th>Virta (A)</th>
                  <th>Jännite (V)</th>
                  <th>Virta alaraja</th>
                  <th>Virta yläraja</th>
                  <th>Jännite alaraja</th>
                  <th>Jännite yläraja</th>
                  <th>Views</th>
                </tr>
              </thead>
              
              <tbody>
                  {site_config && site_config['devices'].map((item, index) => {
    
                    return <Device mcadexinterface={mcadexinterface} item={item} measurements={measurements} userLevel={userLevel} history={history} main_callback={main_callback} />
                  })}
              </tbody>
    
            </Table>
    
          </>
        )
      }
  
    
    }
  
  }
  
  export default Devices